function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { BedIconSmall, BathIconSmall, ParkingIconSmall, PinIconSmall } from '@domain-group/fe-co-icon';
import { AverageStarRatingAndTotal } from '@domain-group/fe-co-allhomes-average-star-rating-and-total';
import { Card as DesignSystemCard } from '@domain-group/fe-co-allhomes-design-system';
import { reviewTypeMap, truncateTextToNearestSpace } from './utils';
import * as styles from './card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Card = _ref => {
  var _detailedState$abbrev;
  var title = _ref.title,
    date = _ref.date,
    type = _ref.type,
    description = _ref.description,
    propertyFeatures = _ref.propertyFeatures,
    propertyAddress = _ref.propertyAddress,
    rating = _ref.rating;
  var MAX_DESCRIPTION_LENGTH = 100;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var bedrooms = propertyFeatures.bedrooms,
    bathrooms = propertyFeatures.bathrooms,
    parking = propertyFeatures.parking;
  var streetAddress = propertyAddress.streetAddress,
    suburb = propertyAddress.suburb,
    detailedState = propertyAddress.detailedState,
    postcode = propertyAddress.postcode;
  var address = "".concat(streetAddress, ", ").concat(suburb, " ").concat(detailedState === null || detailedState === void 0 ? void 0 : (_detailedState$abbrev = detailedState.abbreviation) === null || _detailedState$abbrev === void 0 ? void 0 : _detailedState$abbrev.toUpperCase(), " ").concat(postcode);
  var truncatedDescription = truncateTextToNearestSpace(description, MAX_DESCRIPTION_LENGTH);
  var isTruncated = truncatedDescription.length < description.length;
  return ___EmotionJSX(DesignSystemCard, {
    css: styles.card(isTruncated),
    onClick: () => setIsExpanded(!isExpanded)
  }, ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("div", null, rating ? ___EmotionJSX(AverageStarRatingAndTotal, {
    size: "s",
    averageRating: rating
  }) : null), ___EmotionJSX("div", null, reviewTypeMap[type], " recommendation | ", moment(date).fromNow())), ___EmotionJSX("div", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.subtitle
  }, ___EmotionJSX("div", {
    css: styles.pinAddress
  }, propertyAddress && ___EmotionJSX(PinIconSmall, {
    css: styles.icon
  }), ___EmotionJSX("div", {
    css: styles.address
  }, address)), ___EmotionJSX("div", {
    css: styles.subtitleDivider
  }, "\xB7"), ___EmotionJSX("div", {
    css: styles.subtitleSuffix
  }, ___EmotionJSX("div", {
    css: styles.featureContainer
  }, ___EmotionJSX(BedIconSmall, {
    css: styles.icon
  }), ___EmotionJSX("div", {
    css: styles.feature
  }, bedrooms || '-')), ___EmotionJSX("div", {
    css: styles.featureContainer
  }, ___EmotionJSX(BathIconSmall, {
    css: styles.icon
  }), ___EmotionJSX("div", {
    css: styles.feature
  }, (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.total) || '-')), ___EmotionJSX("div", {
    css: styles.featureContainer
  }, ___EmotionJSX(ParkingIconSmall, {
    css: styles.icon
  }), ___EmotionJSX("div", {
    css: styles.feature
  }, (parking === null || parking === void 0 ? void 0 : parking.total) || '-')))), ___EmotionJSX("p", {
    css: styles.message(isExpanded, isTruncated)
  }, isExpanded ? description : truncatedDescription)));
};
Card.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  description: PropTypes.string,
  propertyFeatures: PropTypes.shape({
    bedrooms: PropTypes.number,
    bathrooms: PropTypes.shape({
      total: PropTypes.number
    }),
    parking: PropTypes.shape({
      total: PropTypes.number
    })
  }).isRequired,
  propertyAddress: PropTypes.shape({
    streetAddress: PropTypes.string,
    suburb: PropTypes.string,
    detailedState: PropTypes.shape({
      abbreviation: PropTypes.string
    }),
    postcode: PropTypes.string
  }).isRequired,
  rating: PropTypes.number
};
Card.defaultProps = {
  description: '',
  rating: null
};
export { Card };